import { createSlice } from "@reduxjs/toolkit";
import { educationVendorCheckOrCreate } from "../CommunityAPI/communityApi";

const educationVendorCheckOrCreateSlice = createSlice({
  name: "educationVendorCheckOrCreate",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(educationVendorCheckOrCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(educationVendorCheckOrCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(educationVendorCheckOrCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default educationVendorCheckOrCreateSlice.reducer;
